import { HttpErrorResponse } from "@angular/common/http";
import { Component, Injector, OnInit } from "@angular/core";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { catchError, tap } from "rxjs/operators";
import { StakeholderServicesService } from "../stakeholder-services.service";

@Component({
    selector: "adapt-export-leaders-owners",
    templateUrl: "./export-leaders-owners.component.html",
    standalone: false,
})
export class ExportLeadersOwnersComponent extends BaseRoutedComponent implements OnInit {
    public result?: string;

    public includeOrgLeaders = true;
    public includeTeamLeaders = false;
    public includeFunctionLeaders = false;
    public includeCulturalLeaders = false;
    public includeOwners = true;
    public includeStrategicPartnerCoachedOrganisations = false;

    public constructor(
        private stakeholderServices: StakeholderServicesService,
        injector: Injector,
    ) {
        super(injector);
    }

    public ngOnInit() {
        this.notifyActivated();
    }

    @Autobind
    public generateList() {
        return this.stakeholderServices.exportLeadersOwners({
            IncludeOrgLeaders: this.includeOrgLeaders,
            IncludeTeamLeaders: this.includeTeamLeaders,
            IncludeFunctionLeaders: this.includeFunctionLeaders,
            IncludeCulturalLeaders: this.includeCulturalLeaders,
            IncludeOwners: this.includeOwners,
            IncludeStrategicPartnerCoachedOrganisations: this.includeStrategicPartnerCoachedOrganisations,
        })
            .pipe(
                tap((response) => {
                    this.result = undefined;
                    saveAs(response!.body!, "LeadersAndOwners.csv");
                }),
                catchError((error: HttpErrorResponse) => {
                    this.result = error.error;
                    throw error;
                }),
            );
    }
}
